<template>
 
<a href="/" class="mobileLogo">  <img class="img-fluid " style="margin-top: 4px; max-height: 50px;" @click="pushToHome" src="/img/lhm_logo_w.png" /></a>
 
  <!-- <img src="~assets/img/logo1.png" /> -->
  
</template>

<script>
export default {
  name: 'Logo',
  methods:{
    pushToHome(){
      this.$router.push({path: '/'});
    }
  }
}
</script>
<style> 
@media screen and (max-width: 768px){
    .mobileLogo img{
      float: left;
      padding-left: 5px;
      height: 50px;
      margin-top: 0 !important;
    }
  .mobileLogo{
    float: left;
    /* width: 85%; */
    margin-top: 4px;
    margin-left: 30px;
  }
  .landing_loginDesktop{
    float: left;
  }
  .navigation.landingNavigation{
    flex-direction: row;
  }
}

</style>